export const endpointCrmcontact = `${process.env.TIDE_HOST}/api/web/crmcontact`;
export const endpointContact = `${process.env.TIDE_HOST}/api/web/contactform`;
export const endpointOffer = `${process.env.TIDE_HOST}/api/web/booking/offer-entry`;
